import styled from "styled-components";

const Base = styled.p`
  font-weight: 600;
`;

const Title = Base.withComponent("h1").extend`
  font-size: 22px;
  @media(min-width: 960px) {
    font-size: 32px;
  }
`;

export { Title };



// WEBPACK FOOTER //
// ./src/UI/Title/Title.js